/**
 * little-state-machine reducer for form state
 * Supports one of each form type
 */
const clearForm = root => {
    const formName = root || 'newForm';

    return (state, payload) => {
        return {
            ...state,
            forms: {
                ...state.forms,
                [formName]: {},
            },
        };
    };
};

export default clearForm;
